import { Card } from "@mui/material";
import { truncate } from "../../Calendar/calendarFunctions";
import "./workflow-chip-2023.css";

const WorkflowChip2023 = ({
  workflow,
  setOpenWorkflowModal2023,
  getNotesAboutModal,
}) => {
  const openUpTheWorkflow = () => {
    getNotesAboutModal(workflow.todoId, "tasksId", workflow.todoName);
    setOpenWorkflowModal2023(workflow);
  };

  return (
    <Card className="workflow-chip-2023" onClick={() => openUpTheWorkflow()}>
      <div className="workflow-chip-2023__name">
        {truncate(workflow.todoName, 27)}
      </div>
      <div
        className="workflow-chip-2023__school"
        style={
          workflow.whichSchool
            ? { border: "1px solid gray" }
            : { border: "none" }
        }
      >
        {workflow.whichSchool && workflow.whichSchool.toUpperCase()}
      </div>
      {workflow.todoSubtasks.filter((task) => !task.subtaskCompleted && task)
        .length !== 0 && (
        <div className="task-chip-2023__tasks-left">
          {
            workflow.todoSubtasks.filter(
              (task) => !task.subtaskCompleted && task
            ).length
          }
        </div>
      )}
    </Card>
  );
};
export default WorkflowChip2023;
